<div class="modal-header">
  <h5 class="modal-title"></h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.close('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-center p-y-40">
  <h6 class="m-0 p-0">{{ message || 'Something went wrong'}}</h6>
</div>
<div class="modal-footer">
  <button class="btn btn-dv btn-clean" (click)="activeModal.close('Cross click')">
    <i class="fa fa-times"></i>
    {{'COMMON.CLOSE' | translate}}
  </button>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/core/information/information.component.html